export default __webpack_public_path__ + "static/Citta200-e8b1f487e035d1d4aa822eea0793c461.png";